import { TripByCountService } from '../services/trip-by-count.service';
import { AuthService } from '../../auth/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { TripByCount } from '../models/tripbycount';
import { switchMap, filter } from 'rxjs/operators';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-trips-by-count-excel',
  templateUrl: './trips-by-count-all.component.html',
  styleUrls: ['./trips-by-count-all.component.scss']
})

export class TripsByCountAllComponent implements OnInit {
  displayedColumns: string[] = ['driver', 'passenger1', 'passenger2', 'passenger3', 'passenger4', 'count', 'date'];
  fileName= 'TripsByCount.xlsx';  
  
  tripsByCount$: Observable<TripByCount[]>;
  myFirstGroup$: Observable<string>;

  isLoading = true;
  appUserAgentCheck: Boolean;

  constructor(
    private tripsByCountService: TripByCountService,
    private authService: AuthService,
  ) { }

  ngOnInit(): void {
    console.log("ngOn")
    this.myFirstGroup$ = this.authService.myfirstgroup$;
    console.log(this.authService.myfirstgroup$)
    const userAgent = window.navigator.userAgent;
    this.appUserAgentCheck = userAgent.includes("carpoolcommute");
    console.log(this.appUserAgentCheck);
    this.getTripCount();    
  }

  public getTripCount() {
    this.authService.myfirstgroup$.pipe(
     switchMap(group => 
      this.tripsByCountService.tripbycount$(group))
  )
  .subscribe(res => {
    this.isLoading = false;   
    this.tripsByCount$ = of(res);
  });
  }

  exportexcel(): void 
    {
       /* table id is passed over here */   
       let element = document.getElementById('excel-table'); 
       const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

       /* generate workbook and add the worksheet */
       const wb: XLSX.WorkBook = XLSX.utils.book_new();
       XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

       /* save to file */
       XLSX.writeFile(wb, this.fileName);
			
    }


}


